<div class="smallimagebox teaser" *ngIf="data && data.headline" [class.mediaright]="data.mediaAlignment === 'right'">
    <div class="column media" *ngIf="data.image">
        <figure>
            <da-progressive-image
                [options]="{
                    alt: data.image.altText ? data.image.altText : data.headline ? data.headline : '',
                    aspectRatios: [
                        {
                            breakpoint: 480,
                            width: 480,
                            height: 360,
                            akamaiImage: data.image.imageUrl
                        },
                        {
                            breakpoint: 768,
                            width: 300,
                            height: 225,
                            akamaiImage: data.image.imageUrl
                        },
                        {
                            breakpoint: 960,
                            width: 380,
                            height: 285,
                            akamaiImage: data.image.imageUrl
                        }
                    ]
                }"
            ></da-progressive-image>
        </figure>
    </div>
    <div class="column copy">
        <div class="copycontent">
            <h2 *ngIf="data.headline" [innerHTML]="data.headline"></h2>
            <div *ngIf="data.copytext && data.copytext.value" [innerHTML]="data.copytext.value | superscripe"></div>
            <p *ngIf="data.button && data.button.url && data.button.url.imageUrl">
                <a
                    da-button
                    [icon]="data.button.text ? '' : 'drg-icon-arrow_level_down'"
                    [link]="data.button.url.imageUrl"
                    [themeType]="data.button.url.linkType === 'document' ? 'Primary' : 'Secondary'"
                    [innerHTML]="data.button.text"
                ></a>
            </p>
        </div>
    </div>
</div>
